import { FC } from 'react'

import { useParams } from 'react-router-dom'

import {
  ResourceDetailView,
  ResourceListView,
  useResourceListPaging,
} from 'core/resources'
import {
  useServicesGet,
  useServicesGetAll,
} from 'core/types/generated/api-internal/hooks'
import { resourceCatalog } from 'core/types/generated/resources'
import { monitoringServicesResponseSchema } from 'core/utils/generated/formSchemas'

import { listRows, record } from './helpers'

const resource = resourceCatalog.monitoringServices

export const MonitoringServicesList: FC = () => {
  const { companyId } = useParams<{ companyId: string }>()
  // servicesGetAll takes no cursor and no offset, only `limit`, which would
  // truncate the list with no way to reach the rest.
  const paging = useResourceListPaging('none')
  const result = useServicesGetAll({ companyId })

  return (
    <ResourceListView
      {...listRows(result)}
      paging={paging}
      resource={resource}
      schema={monitoringServicesResponseSchema}
    />
  )
}

export const MonitoringServiceDetail: FC = () => {
  const { companyId, serviceId } = useParams<{
    companyId: string
    serviceId: string
  }>()
  const result = useServicesGet({ companyId, serviceId })

  return (
    <ResourceDetailView
      {...record(result)}
      resource={resource}
      schema={monitoringServicesResponseSchema}
    />
  )
}
